if (!customElements.get('sticky-header')) {
	customElements.define('sticky-header', class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.stickyDisabled = this.getAttribute('disabled') === 'true';
			this.header = document.querySelector('.section-header');
			this.alwaysSticky = this.dataset.alwaysOn === 'true';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');
			this.isNavigationHidden = false;
			this.scrollThreshold = 30; // 滚动阈值，避免频繁触发
			this.lastScrollTime = 0;
			this.scrollDebounceDelay = 50; // 防抖延迟

			// 延迟获取 navigation-wrapper，确保 DOM 已完全加载
			setTimeout(() => {
				this.navigationWrapper = document.querySelector('.navigation-wrapper');
				if (this.navigationWrapper) {
					// 获取并存储 navigation-wrapper 的实际高度
					this.navigationHeight = this.navigationWrapper.scrollHeight;
					// 设置初始 max-height 为实际高度
					this.navigationWrapper.style.maxHeight = `${this.navigationHeight}px`;
				}
			}, 100);

			if (this.alwaysSticky) {
				this.header.classList.add('section-header-sticky-always');
			}

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => {
				this.preventReveal = true;
			};

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			const now = Date.now();

			if (this.predictiveSearch && this.predictiveSearch.isOpen) {
				return;
			}

			// 防抖处理 navigation-wrapper 的显示/隐藏
			if (now - this.lastScrollTime < this.scrollDebounceDelay) {
				this.currentScrollTop = scrollTop;
				return;
			}

			// 处理 navigation-wrapper 的显示/隐藏
			if (!this.navigationWrapper) {
				this.navigationWrapper = document.querySelector('.navigation-wrapper');
				if (this.navigationWrapper) {
					this.navigationHeight = this.navigationWrapper.scrollHeight;
					// 设置初始 max-height 为实际高度
					this.navigationWrapper.style.maxHeight = `${this.navigationHeight}px`;
				}
			}

			if (this.navigationWrapper) {
				const scrollDiff = Math.abs(scrollTop - this.currentScrollTop);
				
				// 只有滚动距离超过阈值才触发
				if (scrollDiff > this.scrollThreshold) {
					if (scrollTop > this.currentScrollTop && scrollTop > 150) {
						// 向下滚动 - 收起 navigation-wrapper
						if (!this.isNavigationHidden) {
							this.navigationWrapper.classList.add('navigation-hidden');
							this.isNavigationHidden = true;
							this.lastScrollTime = now;
						}
					} else if (scrollTop < this.currentScrollTop) {
						// 向上滚动 - 展开 navigation-wrapper
						if (this.isNavigationHidden) {
							this.navigationWrapper.classList.remove('navigation-hidden');
							this.isNavigationHidden = false;
							this.lastScrollTime = now;
						}
					}
				}
			}

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal && !this.stickyDisabled) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false;
					}, 66);

					requestAnimationFrame(this.hide.bind(this));
				}
			} else if (!this.stickyDisabled && scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this));
			} else if (this.stickyDisabled && scrollTop <= this.headerBounds.bottom) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.alwaysSticky) {
				return;
			}

			this.header.classList.add('section-header-hidden', 'section-header-sticky');

			// Add methods to close dropdowns etc
			this.closeHeaderDropdowns();
		}

		reveal() {
			if (this.alwaysSticky) {
				return;
			}

			this.header.classList.add('section-header-sticky', 'animate');
			this.header.classList.remove('section-header-hidden');
		}

		reset() {
			this.header.classList.remove('section-header-hidden', 'section-header-sticky', 'animate');
		}

		closeHeaderDropdowns() {
			const headerLocalizationDropdowns = this.header.querySelectorAll('localization-form')
			const headerDropdowns = this.header.querySelectorAll('.dropdown-modal');

			headerLocalizationDropdowns.forEach(dropdown => {
				dropdown.hidePanel();
			});
			headerDropdowns.forEach(dropdown => {
				dropdown.close();
			});
		}
	});
}
